import React from "react";

function Tally() {
  return (
    <>
      <section className="services" id="erp">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>Our Services</h2>
              </div>
              <h4 className="text-color">
                <h3>
                  <b>TALLY SOLUTIONS</b>
                </h3>
                <p>
                  <b>
                    Do you know Tally ERP 9 is one of the most popular
                    accounting and monetary application software used in India
                    and worldwide!
                  </b>
                </p>
              </h4>
              <p>
                Tally implementation and installation requires high technical
                expertise and careful execution. Macrozion Techsystems help
                businesses to get it right with their Tally installation and
                implementation. Be it data migration, synchronization, or
                technical support, you can simply rely on us. With more than
                100+ satisfied customers and the accumulated experience of 20+
                years, Macrozion Techsystems makes a trusted service partner for
                your business.{" "}
              </p>
            </div>

            <div className="col-md-8">
              <h3 className="text-color">Our Tally Solutions Expertise</h3>
              <b>Tally Installation and Implementation Services:</b>{" "}
              <p>
                Tally ERP is a feature-rich software and our clients require
                different features to fulfill their business requirements. We
                can configure these features while installing a new license of
                Tally ERP 9 on their systems.
              </p>
              <b>Data Synchronization:</b>{" "}
              <p>
                Our experts help clients with multiple business locations to
                synchronize their data effectively. The data synchronization is
                done using Tally Net.
              </p>
              <b>Data Migration Services:</b>{" "}
              <p>
                Data migration from an old version of Tally to the new version
                can be difficult. Our experts often help clients to migrate data
                from an older version of Tally to the newer version easily.
              </p>
              <b>Annual Maintenance Contract:</b>{" "}
              <p>
                We provide technical Tally support throughout the year beyond
                our business hours. Our AMC enable clients to minimize their
                Tally downtime and effectively utilize it to improve their
                business bottom line.
              </p>
            </div>
            <br></br>
            <div className="col-md-4">
              <p>
                <img
                  src="./images/tally.png"
                  alt="Example1"
                  width="420"
                  height="320"
                ></img>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Tally;
